import { useEffect, useState } from 'react';

import { getProjectRevenueList } from '../../api/constlink';
import RevenueReportComponent from '../../components/expenses/RevenueReportComponent';
import { ProjectStatus } from '../../modules/projects';

interface RevenueReportContainerProps {
  enterpriseId: string;
}

function RevenueReportContainer({ enterpriseId }: RevenueReportContainerProps) {
  const [revenueList, setRevenueList] = useState<any>();

  useEffect(() => {
    (async () => {
      const data = await getProjectRevenueList({ enterpriseId });
      const _data = data
        .filter(
          (item: any) =>
            item.status === ProjectStatus.CLOSED &&
            item.contracts.length > 0 &&
            item.contracts[0].type1 === '0',
        )
        .map((item: any) => {
          const month = item.contracts[0].contractDate.substring(0, 7);
          const type =
            item.type === '' || item.type === null || item.type === undefined
              ? '기타'
              : item.type;
          let value = 0;
          for (let i = 0; i < item.contracts.length; i++) {
            value += item.contracts[i].priceData.priceData.totalPrice;
          }

          for (let i = 0; i < item.changeOrders.length; i++) {
            value += item.changeOrders[i].priceData.priceData.totalPrice;
          }

          return {
            month,
            type,
            value,
          };
        })
        .sort((a: any, b: any) => a.month.localeCompare(b.month));

      setRevenueList(_data);
    })();
  }, [enterpriseId]);

  return <>{revenueList && <RevenueReportComponent data={revenueList} />}</>;
}

export default RevenueReportContainer;
